import React from "react";
import PassionateAboutCrafting from "./passionate_about_crafting/Passionate_About_Crafting";
import VisionMission from "./vision_mission/Vision_Mission";
import WhoWeAreSection from "./who_we_are/Who_We_Are";
import WhyChooseUs from "./why_choose_us/Why_Choose_Us";

function About_Us() {
  return (
    <>
      <PassionateAboutCrafting />
      <WhoWeAreSection/>
      <VisionMission />
      <WhyChooseUs/>
    </>
  );
}

export default About_Us;
